module.exports = __webpack_public_path__ + "img/CLO.70f673a3.svg";